export const DEFAULTS = Object.freeze({
  API: Object.freeze({
    QUERY: Object.freeze({
      PAGE: 1,
      PAGE_SIZE: 10,
      FLEX_LIST_PAGE_SIZE: 12,
    }),
  }),
  USER: Object.freeze({
    DISABLE_PROMOTION: false,
    LOCALE: 'en',
    TIMEZONE_CODE: 'America/Los_Angeles',
  }),
  THRESHOLD: Object.freeze({
    SEARCH: {
      SIMILARITY: {
        DEFAULT: 0.2,
        MODERATE: 0.5,
        STRICT: 0.75,
      },
    },
  }),
});
